import React, {useEffect, useState, useTransition} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import IconFrom from "../../assets/v2/map-pin.png";
import IconTo from "../../assets/v2/goal.png";
import Dot from "../../assets/v2/dot.png";
import useValetStore from "./hooks/useValetStore";
import IconCarFront from "../../assets/v2/car-front.png";
import IconTimer from "../../assets/v2/timer.png";
import RadioSelector from "../../components/v2/RadioSelector";
import {PaymentType} from "../../constants/PaymentType";
import FormatUtils from "../../utils/FormatUtils";
import {RouteType} from "./constants/RouteType";
import moment from "moment";
import Price from "../../components/v2/Price";
import {ValetSteps} from "./constants/ValetSteps";
import ValetRouteGraph from "./ValetRouteGraph";
import {useTranslation} from "react-i18next";
import {GTMTriggers} from "../../constants/GTMTriggers";

export default function ValetSummary({
                                         backClickedHandler,
                                     }) {
    const {
        setStep,
        valetIntent,
        userData,
        setUserData,
    } = useValetStore();

    const {t} = useTranslation('common');

    const [paymentType, setPaymentType] = useState(userData.paymentType ?? PaymentType.CREDIT_CARD);

    useEffect(() => {
        window.dataLayer.push({event: GTMTriggers.PURCHASE_SUMMARY});
    }, [])

    const FormatGoogleAdress = (address) => {
        return address.split(',').map((it, i) => <div key={'x' + i}>{it}</div>)
    }

    const date = moment(userData.travel.date);
    const now = moment();
    const time = now.clone().set({
        hour: userData.travel.time.split(':')[0],
        minute: userData.travel.time.split(':')[1]
    });

    const retrieveTime = now.clone().set({
        hour: userData.travel.retrieveHour.split(':')[0],
        minute: userData.travel.retrieveHour.split(':')[1]
    });

    const getPaymentTypes = () => {
        let paymentTypes = [
            {value: PaymentType.CREDIT_CARD, label: t('valet.summary.payment_cb')},
        ];
        if (userData.can_pay_by_invoice) {
            paymentTypes.push({value: PaymentType.INVOICE, label: t('valet.summary.payment_invoice')})
        }
        return paymentTypes;
    }

    const nextClickedHandler = () => {
        setUserData({
            ...userData,
            ...{
                paymentType: paymentType
            }
        });
        if (paymentType === PaymentType.CREDIT_CARD) {
            setStep(ValetSteps.PAYMENT_STRIPE);
        } else {
            setStep(ValetSteps.PAYMENT_INVOICE);
        }
    }

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={80}/>
        <div className="flex flex-nowrap justify-between items-center">
            <div className="text-white text-[30px] font-bold">{t('valet.summary.title')}</div>
            <Price value={valetIntent.price}/>
        </div>
        <div>
            {t('valet.summary.text')}<b> {userData.travel.routeType === RouteType.GOING ? t('common.route_type_going') : t('common.route_type_going_and_coming')}</b> {t('common.of')} {FormatUtils.formatDistance(valetIntent.gmap_distance)}.
        </div>

        <div className="flex flex-nowrap justify-between items-center gap-3">
            <div
                className="rounded-xl bg-white font-bold text-black flex flex-col justify-center items-center p-1 w-1/6">
                <div><b>{date.format('ddd').toUpperCase()}</b></div>
                <div className="text-red-600 text-4xl mt-[-8px] mb-[-6px]">{date.format('D')}</div>
                <div className="text-xs"><b>{date.format('MMM').toUpperCase()}</b></div>
            </div>
            <div className="flex-grow h-full rounded-2xl bg-[#cdcdcd] text-black flex items-center w-5/6">
                <div><img className="m-5" src={IconCarFront} alt="car"/></div>
                <div className="flex-grow"><b>{userData.vehicle.model}</b>
                    <br/>{t('valet.summary.text1')} {userData.vehicle.licence_plate}
                </div>
            </div>
        </div>


        <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
            <legend className="text-sm">&nbsp;{t('valet.summary.text2')}&nbsp;</legend>
            <div className="flex">
                <ValetRouteGraph routeType={userData.travel.routeType}/>
                <div className="grow">
                    <div><b>{t('valet.summary.text3')} - {time.format('HH')}H{time.format('mm')}</b></div>
                    {FormatGoogleAdress(valetIntent.gmap_origin)}
                    <div>{t('valet.summary.contact')} {userData.travel.phone}</div>
                    <div className="mt-3"></div>
                    <div><b>{t('valet.summary.text4')}</b></div>
                    {FormatGoogleAdress(valetIntent.gmap_destination)}
                    <div>{t('valet.summary.contact')} {userData.travel.deliveryContactPhone}</div>
                </div>
            </div>
            {userData.travel.routeType === RouteType.GOING_AND_COMING ?
                <div className="flex mt-5 mb-3 text-[#f9b712]">
                    <div className="w-[32px] mr-3"><img src={IconTimer} className="mx-auto max-w-xs"/></div>
                    <div><b>{t('valet.summary.text5')} {retrieveTime.format('HH')}H{retrieveTime.format('mm')}</b></div>
                </div> : null}
        </fieldset>
        <RadioSelector id={"route_type"} value={paymentType} values={getPaymentTypes()}
                       onChange={(value) => setPaymentType(value)}/>
        <div className="grow">
        </div>
        <div className="flex gap-4">
            <Button outline text={<div>
                <div>{t('valet.summary.back')}</div>
                <div className="text-sm mt-[-8px]">{t('valet.summary.text6')}</div>
            </div>} clickHandler={backClickedHandler}/>
            <Button text={t('valet.summary.continue')} clickHandler={nextClickedHandler}/>
        </div>

    </div>
}